import React, {forwardRef} from 'react';
import {Link as ReactLink} from 'react-router-dom';

import {useMagic, useNavPos} from '../../hooks';
import {navPosition} from '../../mapsight-glue/routing/nav-pos';

// we need support for any <Link> in jsx-a11y/anchor-has-content. this is not the right place to complain.
// most time we will have content, it's member children inside props
/* eslint-disable jsx-a11y/anchor-has-content */


/**
 * @param {{
 *   to: string | {
 *     pathname: string,
 *     state?: null | {
 *         area: string | null,
 *         nunav: {name: string, link: string | null, longitude: string | null, latitude: string | null},
 *         select: string | null,
 *     },
 *   },
 *   external?: boolean,
 * } & Record<any, any>} props
 * @returns {JSX.Element}
 */
const Link = forwardRef(({to, external, ...props}, ref) => {
	const navPos = useNavPos();
	const magic = useMagic();

	if (typeof to === 'string') {
		to = {/**string*/pathname: to};
	}

	const toNavPos = navPosition(magic, to.pathname, to.state);

	if (
		external ||
		(!toNavPos.app && !navPos.app) ||
		(toNavPos.app && navPos.app && toNavPos.url !== navPos.url)
	) {
		return <a ref={ref} href={to.pathname} {...props} />;
	}

	if (!toNavPos.app && navPos.app) {
		console.log('Link adding app url', {navPos, to, result: (navPos.app.url + to.pathname), resultType: typeof (navPos.app.url + to.pathname)});
		to.pathname = (navPos.app.url + to.pathname).replace('//','/');
	}

	return (<ReactLink ref={ref} to={to} {...props} />);
});


export default Link;
